







import Vue from 'vue';
import Component from 'vue-class-component';
import AccessPermissionsListHeader from '../components/AccessPermissionsListHeader.vue';
import AccessPermissionsList from '../components/AccessPermissionsList.vue';

@Component({
    components: { AccessPermissionsListHeader, AccessPermissionsList },
})
export default class AccessPermissions extends Vue {}
